module.exports = __webpack_public_path__ + "static/media/shingleBurntSienna.3ff7409c.png";